<template>
  <div class="PageComponent">
    <link
      rel="stylesheet"
      href="https://unpkg.com/leaflet@1.8.0/dist/leaflet.css"
      integrity="sha512-hoalWLoI8r4UszCkZ5kL8vayOGVae1oxXe/2A4AO6J9+580uKHDO3JdHb7NzwwzK5xr/Fs0W40kiNHxM9vyTtQ=="
      crossorigin=""
    />
  </div>
</template>

<script>
import '../../public/css/netjsongraph-theme.css';
import '../../public/css/netjsongraph.css';
import axios from 'axios';
import { lighten } from 'polished';
export default {
  name: 'SimulatorComponent',
  props: ['layer1Id', 'layer2Id', 'topologyId'],
  metaInfo: {
    title: '脆弱性シミュレーション',
    meta: [
      {
        name:"viewport",
        content:"width=device-width, initial-scale=1.0" 
      },
    ],
  },

  mounted() {
    this.loadExternalScript();
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.8.0/dist/leaflet.css';
    link.crossorigin = '';
    document.head.appendChild(link);
  },
  methods: {
    // 外部スクリプトが読み込まれた後、NetJSONGraphのインスタンスを作成
    loadExternalScript() {
      const scriptTag = document.createElement("script");
      scriptTag.type = "application/javascript";
      scriptTag.src = "/dist/netjsongraph.min.js";
      scriptTag.onload = async() => {
        //AP情報(Node)のレイアウト設定 node.ASNRegionalTierの値によって変化。
        const NodeStyle = {
          1: {
            opacity: 1,
                    borderWidth: 1,
                    borderColor: '#000',
                    color: '#2ca9e1',//blue
          },
          2: {      
            opacity: 1,
                    borderWidth: 1,
                    borderColor: '#000',
                    color: '#b8d200',//green
          },
          3: {      
            opacity: 1,
                    borderWidth: 1,
                    textColor:'#444',
                    borderColor: '#000',
                    color: '#ffd900',//yellow
          },
          4: {      
            opacity: 1,
                    borderWidth: 1,
                    textColor:'#444',
                    borderColor: '#000',
                    color: '#ffd900',
          },
          5: {      
            opacity: 1,
                    borderWidth: 1,
                    textColor:'#444',
                    borderColor: '#000',
                    color: '#ffd900',
          },
          6: {      
            opacity: 1,
                    borderWidth: 1,
                    textColor:'#444',
                    borderColor: '#000',
                    color: '#fff200',
          },
          9: {      
            opacity: 1,
                    borderWidth: 1,
                    textColor:'#444',
                    borderColor: '#000',
                    color: '#ff8400',//#orange
          }
        };
        //POI情報(link)のレイアウト設定 link.Relationship_A_Bの値によって変化。
        const LinkStyle = {
          1: {
            r: 3,
            opacity: 1,
            color: "#29B8DB",//aqua
          },
          2: {
            r: 2,
            color: "#0BE0A0",//mint
            opacity: 1
          },
          3: {
            r: 1,
            color: "#778899",//lightslategray
            opacity: 1,
          },
          4: {
            r: 0.5,
            opacity: 0.5,
            curveness:0.2,
            color: "#778899",//lightslategray
            type: 'dashed'
          }
        };
        //各layerごとに出される結果を分岐させる。
        const queryParams = this.$route.query;
        const layer1Id = queryParams.layer1_id;
        const layer2Id = queryParams.layer2_id;
        const topologyId = queryParams.topology_id;
        let response;
        //デプロイ用 https://jpisp-sim.com:3000
        //新規開発版 https://tk2-216-17629.vs.sakura.ne.jp:3000
        //ローカル用 http://localhost:3000
        if (layer1Id && layer2Id && topologyId) {
          console.log("トポロジー Topology="+topologyId+",layer1="+layer1Id+",layer2="+layer2Id)
          response = await axios.get(`https://jpisp-sim.com:3000/reload-topology?layer1_id=${layer1Id}&layer2_id=${layer2Id}&topology_id=${topologyId}`);
        } else if(layer1Id && layer2Id) {
          console.log("レイヤー2 Topology="+topologyId+",layer1="+layer1Id+",layer2="+layer2Id)
          response = await axios.get(`https://jpisp-sim.com:3000/reload-layer2?layer1_id=${layer1Id}&layer2_id=${layer2Id}`);
        } else if(layer1Id) {
          console.log("レイヤー1 Topology="+topologyId+",layer1="+layer1Id+",layer2="+layer2Id)
          response = await axios.get(`https://jpisp-sim.com:3000/reload-layer1?layer1_id=${layer1Id}`);
        } else{
          console.log("レイヤー0 Topology="+topologyId+",layer1="+layer1Id+",layer2="+layer2Id)
          response = await axios.get('https://jpisp-sim.com:3000/reload-layer0')
        }
        const graph = new window.NetJSONGraph(response.data, {
          //dealDataByWorker: "/simulator/js/netjsonWorker.js",

          nodeSize: node => {
              switch (node.ASNRegionalTier) {
                case 1:
                return Math.sqrt(4000);
                case 2:
                return Math.sqrt(2000);
                case 3:
                return Math.sqrt(500);
                case 9:
                return Math.sqrt(1500);
                default:
                return Math.sqrt(500);
              }
          },
            linkStyleProperty: link => {
              const baseStyle = LinkStyle[link.Relationship_A_B] || {};
              return Object.assign({}, baseStyle);
            },
            nodeStyleProperty: node => {
                return Object.assign({
                opacity: 1,
                borderWidth: 1,
                borderColor: '#fff',         
                }, NodeStyle[node.ASNRegionalTier])
            },
      graphConfig: {
        color:"#2cb4ad",
        invisible: false,
      },
      mapTileConfig: [{
                urlTemplate: "https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png",
                options: {
                    minZoom: 0.25, 
                    maxZoom: 18,
                }
            }],
        mapOptions: {
          center: [36,139],
          zoom: 7,
        },
        maintainAspectRatio: true,
        prepareData: (data) => {
          data.nodes.map((node) => {
            node.label = node.name;
            node.properties = Object.assign(node.properties || {}, {
            location: node.location,
            APサービス種別: node.ap_service_func,
            アクセス網接続: node.ap_func_access_network,
            国内Tier: node.ASNRegionalTier,
            AS番号: node.asn,
            AS名: node.as_name,
            ASネットワーク種別: node.as_info_type,
            施設名称: node.facility_name,
            施設管理組織名: node.facility_manag_org,
            施設所在国: node.facility_country,
            施設郵便番号: node.facility_zip_code,
            施設都道府県: node.facility_state,
            施設市町村: node.facility_city,
            組織名: node.org_name,
            組織登録国: node.org_country,
            作成日時: node.create_date,
            住所1: node.add1,
            住所2: node.add2
            });
          });
          data.nodes.map(node => {
            // 特定の AP サービスタイプに対して、異なる記号を設定する:
                    switch (node.ap_service_func) {
                      case 3:
                        // 六角形
                        node.symbol = 'path://M0,-10 L8.660254,-5 L8.660254,5 L0,10 L-8.660254,5 L-8.660254,-5 Z';
                        break;
                      case 2:
                        // クラウドアイコン
                        node.symbol = 'path://M-12,2 a6,6 0 0 1 6,-6 a9,9 0 0 1 14,3 a6,6 0 0 1 4,6 a6,6 0 0 1 -6,6 h-18 a6,6 0 0 1 -6,-6 a6,6 0 0 1 2,-3 z';
                        break;
                      case 4:
                        // 円柱アイコン
                        node.symbol = 'path://M-18,-8 a18,8 0 1,0 36,0 a18,8 0 1,0 -36,0 M-18,-8 v24 a18,8 0 1,0 36,0 v-24 M-18,16 a18,8 0 1,0 36,0 a18,8 0 1,0 -36,0';
                        break;
                    }

                    node.properties = Object.assign(node.properties || {}, {
                        category: "tier" + node.ASNRegionalTier,
                    })
                });
          data.links.map((link) => {
            link.properties = link.properties || {};
            if (link.properties.status) {
              link.category = link.properties.status;
            }
          });
          data.links.map((link) => {
            link.properties = Object.assign(link.properties || {}, {
              ポイントAB間POIのID: link.poi_id,
              POI名称: link.poi_name,
              回線容量Gbps: link.nw_band_width,
              平均使用率AからB: link.average_utilization_a_out,
              平均使用率BからA: link.average_utilization_a_in,
              最頻使用率AからB: link.peak_utilization_a_out,
              最頻使用率BからA: link.peak_utilization_a_in,
              回線運用状態: link.nw_operational_status,
              作成日時: link.create_date
            });
          });
      },
onLoad: function() {
    createNavigationMenu(this);
    SwitchLinkStyle(this);
    this.utils.hideLoading();
    
    // 検索ボックスを作成
    let searchContainer = document.createElement("div"),
        searchInput = document.createElement("input"),
        searchBtn = document.createElement("button"),   
        clearBtn = document.createElement("button"),
        searchSelect = document.createElement("select");
    searchInput.setAttribute("class", "njg-searchInput");
    searchBtn.setAttribute("class", "njg-searchBtn");
    clearBtn.setAttribute("class", "njg-searchBtn");
    searchBtn.innerHTML = "検索";
    clearBtn.innerHTML = "クリア";
    searchContainer.setAttribute("class", "njg-searchContainer");
    
    // ドロップダウンのオプションを追加
    const searchOptions = [
        { value: "name", label: "AP名で検索" },
        { value: "asn", label: "AS番号で検索" },
        { value: "ap_id", label: "AP番号で検索" }
    ];
    searchOptions.forEach(option => {
        const opt = document.createElement("option");
        opt.value = option.value;
        opt.innerText = option.label;
        searchSelect.appendChild(opt);
    });
    searchSelect.setAttribute("class", "njg-searchSelect");

    // 検索ボックスに要素を追加
    searchContainer.appendChild(searchSelect);
    searchContainer.appendChild(searchInput);
    searchContainer.appendChild(searchBtn);
    searchContainer.appendChild(clearBtn);
    this.el.appendChild(searchContainer);

    // 検索ボタンのクリックイベント
    searchBtn.onclick = () => {
        const searchValue = searchInput.value.trim();
        const searchMode = searchSelect.value;
        const nodes = this.data.nodes;

        // 条件に応じたノードのフィルタリング
        const matchedNodes = nodes.filter(node => {
            switch (searchMode) {
                case "name":
                    return node.name && node.name.includes(searchValue);
                case "asn":
                    return node.asn && node.asn == searchValue;
                case "ap_id":
                    return node.id && node.id == searchValue;
                default:
                    return false;
            }
        });

        if (matchedNodes.length > 0) {
            nodes.forEach(node => {
                // 分類属性が常に存在することを保証する
                node.properties = Object.assign(node.properties || {}, {
                    category: "tier" + node.ASNRegionalTier,
                });

                if (!matchedNodes.includes(node)) {
                    // 検索結果に一致しないノード
                    node.customStyle = {
                        ...NodeStyle[node.ASNRegionalTier],
                        color: lighten(-0.15, NodeStyle[node.ASNRegionalTier].color),
                        size: nodeSize(node),
                    };
                } else {
                    // 検索結果に一致するノード
                    node.customStyle = {
                        ...NodeStyle[node.ASNRegionalTier],
                        opacity: NodeStyle[node.ASNRegionalTier].opacity,
                        size: nodeSize(node),
                    };
                }
            });

            // グラフを再描画
            this.echarts.setOption({
                series: [
                    {
                        data: nodes.map(node => ({
                            ...node,
                            category: node.properties.category,
                            itemStyle: {
                                color: node.customStyle.color,
                                borderColor: node.customStyle.borderColor,
                                opacity: node.customStyle.opacity,
                            },
                            symbolSize: node.customStyle.size,
                        })),
                    },
                ],
            });
        } else {
            //console.log("一致するノードがありません");
        }
    };

    // クリアボタンのクリックイベント
    clearBtn.onclick = () => {
        const nodes = this.data.nodes;

        // すべてのノードスタイルをリセット
        nodes.forEach(node => {
            // 分類属性の保持を確認する
            node.properties = Object.assign(node.properties || {}, {
                category: "tier" + node.ASNRegionalTier,
            });

            node.customStyle = {
                ...NodeStyle[node.ASNRegionalTier],
                size: nodeSize(node),
            };
        });
        this.echarts.setOption({
            series: [
                {
                    data: nodes.map(node => ({
                        ...node,
                        category: node.properties.category,
                        itemStyle: {
                            color: node.customStyle.color,
                            borderColor: node.customStyle.borderColor,
                            opacity: node.customStyle.opacity,
                        },
                        symbolSize: node.customStyle.size,
                    })),
                },
            ],
        });
        this.utils.hideLoading();
        // 検索フィールドと選択状態をクリア
        searchInput.value = "";
        searchSelect.value = "name";
        console.log("検索結果がクリアされました");
    };
          function nodeSize(node) {
              switch (node.ASNRegionalTier) {
                  case 1:return Math.sqrt(4000);
                  case 2:return Math.sqrt(2000);
                  case 3:return Math.sqrt(500);
                  case 9:return Math.sqrt(1500);
                  default:return Math.sqrt(500);
            }}
},
        });
        graph.render();
        window.myGraph = graph;
        // Process auto layout only when the diagram is truly ready.
        graph.event.on('onLoad', () => {
          const enabled = window.getAutoLayoutEnabled();
          window.setAutoLayoutEnabled(enabled);
          window.syncAutoLayoutIcon(enabled);
          if (enabled) {
            window.runAutoLayout();
          }
        });

        function createNavigationMenu(_this) {
          const navContainer = document.createElement("div");
          navContainer.setAttribute("class", "navigation-container");
          const burgerButton = document.createElement("button");//バーガーボタン作成
          burgerButton.setAttribute("class", "burger-button");
          burgerButton.innerHTML = "☰";
          const navMenu = document.createElement("div");//折り畳み部分
          navMenu.setAttribute("class", "nav-menu");
          navMenu.style.display = "none";
          
          burgerButton.onclick = () => {
            navMenu.style.display = navMenu.style.display === "none" ? "block" : "none";
          };
          const graphModeButton = switchGraphMode(_this);
          const drawingButton = switchDrawing(_this);
          const drawingPyramid = switchPyramid(_this);
          navMenu.appendChild(graphModeButton);
          navMenu.appendChild(drawingButton);
          navMenu.appendChild(drawingPyramid); // メニューにボタン追加
          navContainer.appendChild(burgerButton);
          navContainer.appendChild(navMenu);
          _this.el.appendChild(navContainer);//graph親要素に追加。
        }

        
        function switchGraphMode(_this) {
          const selectIconContainer = document.createElement("div");
          const iconImage = document.createElement("img");
          iconImage.src = "/dist/css/japan_map.jpeg";
          iconImage.style.cursor = "pointer";
          const tooltip = document.createElement("div");
          tooltip.textContent = "地図切替";
          tooltip.className = "tooltip";
          selectIconContainer.appendChild(iconImage);
          selectIconContainer.appendChild(tooltip);
          
          iconImage.addEventListener("mouseenter", () => {
            tooltip.classList.add("visible"); // 表示用クラスを追加
          });
          iconImage.addEventListener("mouseleave", () => {
            tooltip.classList.remove("visible"); // 表示用クラスを削除
          });
          
          iconImage.onclick = () => {
            if (_this.config.render != _this.utils.mapRender) {
              const container = _this.echarts?.getDom?.()
              container.style.width = "2560px";
              container.style.height = "1279px";
              _this.config.render = _this.utils.mapRender;
              _this.config.render(_this.data, _this);
            }
            document.querySelectorAll('.nav-menu')
              .forEach(el => el.style.display = 'none');
          };
            return selectIconContainer;
        }
        
        function SwitchLinkStyle(_this) {
          const switchLinkStyleButton = document.createElement("div"); // ボタン用のコンテナ
          switchLinkStyleButton.style.position = "fixed";
          switchLinkStyleButton.style.bottom = "10px";
          switchLinkStyleButton.style.left = "70px"; // 固定位置
          const iconButton = document.createElement("button"); // ボタン要素に変更
          iconButton.innerHTML = "！"; // ボタンの中身
          iconButton.setAttribute("class", "burger-button"); // クラスを適用してレイアウトを統一
          const tooltip = document.createElement("div"); // ツールチップ
          tooltip.textContent = "逼迫状況表示";
          tooltip.className = "tooltip";
          switchLinkStyleButton.appendChild(iconButton);
          switchLinkStyleButton.appendChild(tooltip);
          iconButton.addEventListener("mouseenter", () => {
            tooltip.classList.add("visible");
          });
          iconButton.addEventListener("mouseleave", () => {
            tooltip.classList.remove("visible");
          });
          
          let isDefaultStyle = true;
              iconButton.onclick = () => {
                isDefaultStyle = !isDefaultStyle; // スタイルをトグル
                if (isDefaultStyle) {
                  // 元のスタイルに戻す
                  _this.config.linkStyleProperty = link => {return LinkStyle[link.Relationship_A_B] || {};};
                } else {
                  _this.config.linkStyleProperty = link => {
                    const baseStyle = LinkStyle[link.Relationship_A_B] || {};
                    let calculatedWidth;
                    let calculatedColor;
                    // 線の太さ変更
                    if (link.nw_band_width <= 10) {
                      calculatedWidth = 1;
                    } else if (link.nw_band_width >= 10 && link.nw_band_width <= 99) {
                      calculatedWidth = 5;
                    } else if (link.nw_band_width >= 100) {
                      calculatedWidth = 10;
                    }
                    // 線の色変更
                    const utilizationPercentage = ((link.average_utilization_a_in + link.average_utilization_a_out) / 100) * link.nw_band_width;
                    const percentageOfBandwidth = (utilizationPercentage / link.nw_band_width) * 100;
                    if (percentageOfBandwidth === 0) {
                      calculatedColor = '#BFBFBF'; // default
                    } else if (percentageOfBandwidth > 0 && percentageOfBandwidth <= 10) {
                      calculatedColor = '#BFBFBF'; // gray(pale)
                    } else if (percentageOfBandwidth > 10 && percentageOfBandwidth <= 40) {
                      calculatedColor = '#B3D5FF'; // blue(pale)
                    } else if (percentageOfBandwidth > 40 && percentageOfBandwidth <= 70) {
                      calculatedColor = '#FFABB0'; // pink(pale)
                    } else if (percentageOfBandwidth > 70 && percentageOfBandwidth < 100) {
                      calculatedColor = '#FF6E76'; // carmine(pale)
                    } else if (percentageOfBandwidth >= 100) {
                      calculatedColor = '#EB1A28'; // red(pale)
                    } else {
                      calculatedColor = '#BFBFBF'; // default
                    }
                  return Object.assign({}, baseStyle, {
                    width: calculatedWidth,
                    color: calculatedColor
                  });
                };
              }
                // グラフのリンク情報のみ再描画
                _this.echarts.setOption({series: [{type: 'graph',links: _this.data.links.map(link => ({...link,lineStyle: _this.config.linkStyleProperty(link)}))}]}, false);
              };
                document.body.appendChild(switchLinkStyleButton);
          }

        function switchDrawing(_this) {
          const selectIconContainer = document.createElement("div");
          const iconImage = document.createElement("img");
          iconImage.src = "/dist/css/drawing.jpeg";
          iconImage.style.cursor = "pointer";
          const tooltip = document.createElement("div");
          tooltip.textContent = "緯度表示";
          tooltip.className = "tooltip";
          selectIconContainer.appendChild(iconImage);
          selectIconContainer.appendChild(tooltip);
    
          iconImage.addEventListener("mouseenter", () => {
            tooltip.classList.add("visible");
          });
          iconImage.addEventListener("mouseleave", () => {
            tooltip.classList.remove("visible");
          });

          iconImage.onclick = () => {
            _this.config.render = _this.utils.graphRender;
            const newScriptTag = document.createElement("script");
            newScriptTag.type = "application/javascript";
            newScriptTag.src = "/dist/netjsongraph.min.js";
            newScriptTag.onload = () => { 
              const clonedData = {
                ..._this.data,
                nodes: _this.data.nodes.map(n => {
                  const fix = window.myGraph.fixedNodes?.find(f => f.id === n.id);

                  if (fix) {
                    return {
                      ...n,
                      x: fix.x,
                      y: fix.y,
                      fixed: true
                    };
                  }

                  const copy = { ...n };
                  return copy;
                })
              };
              const cfg =  _this.config;
              const bounds = window.myGraph.bounds;
              if (bounds) {
                const container = _this.echarts?.getDom?.()
                container.style.width = bounds.width + "px";
                container.style.height = bounds.height + "px";
                cfg.graphConfig.center = [bounds.width/2, bounds.height/2]
              }

              const graph = new window.NetJSONGraph(clonedData, {
                ...cfg,
                el: _this.el,
              });
              graph.render();
              window.myGraph = graph;
              graph.event.on('onLoad', () => {
                const enabled = window.getAutoLayoutEnabled();
                window.syncAutoLayoutIcon(enabled,graph);
                if (enabled) {
                  window.runAutoLayout();
                }
              });
              _this.utils.hideLoading();
            };
            document.body.appendChild(newScriptTag);
          };
          return selectIconContainer;
        }
        function switchPyramid(_this) {
          const selectIconContainer = document.createElement("div");
          const iconImage = document.createElement("img");
          iconImage.src = "/dist/css/pyramid.jpeg";
          iconImage.style.cursor = "pointer";
          const tooltip = document.createElement("div");
          tooltip.textContent = "ピラミッド表示";
          tooltip.className = "tooltip";
          selectIconContainer.appendChild(iconImage);
          selectIconContainer.appendChild(tooltip);
    
          iconImage.addEventListener("mouseenter", () => {
            tooltip.classList.add("visible");
          });
          iconImage.addEventListener("mouseleave", () => {
            tooltip.classList.remove("visible");
          });

          iconImage.onclick = () => {
            _this.config.render = _this.utils.graphRender;
            const newScriptTag = document.createElement("script");
            newScriptTag.type = "application/javascript";
            newScriptTag.src = "/dist/netjsongraph2.min.js";
            newScriptTag.onload = () => {
              const clonedData = {
                ..._this.data,
                nodes: _this.data.nodes.map(n => {
                  const copy = { ...n };
                  delete copy.x;
                  delete copy.y;
                  delete copy.fixed;
                  return copy;
                })
              };
              const container = _this.echarts?.getDom?.()
              container.style.width = "2560px";
              container.style.height = "1279px";

              const bounds = window.myGraph.bounds;
              if (bounds) {
                delete _this.config.graphConfig.center
              }

              const graph = new window.NetJSONGraph(clonedData, {
                ..._this.config,
                el: _this.el,
              });
              graph.render();
              window.myGraph2 = graph;
              _this.utils.hideLoading();
            };
            document.body.appendChild(newScriptTag);
          };
          return selectIconContainer;
        }     
      };
      document.body.appendChild(scriptTag);
    },
    }};
</script>
<style>
</style>